import { graphql, useStaticQuery } from 'gatsby';

interface KeyValuePairCollection {
  edges: {
    node: {
      key: string;
      value: string;
    }
  }[];
}

const kvPairAdapter = (
  data: { en: KeyValuePairCollection, fr: KeyValuePairCollection },
  locale: string,
): Record<string, string> => {
  const collection = data[locale as 'en' | 'fr'];

  if (!collection) {
    return {};
  }

  return collection.edges.reduce<Record<string, string>>((acc, edge) => {
    acc[edge.node.key] = edge.node.value;
    return acc;
  }, {});
};

const useKeyValuePairs = (locale: string): Record<string, string> => {
  const query = graphql`
    query {
      en: allContentfulKeyValuePair(filter: { node_locale: { eq: "en-CA" }}) {
        edges {
          node {
            key
            value
          }
        }
      },
      fr: allContentfulKeyValuePair(filter: { node_locale: { eq: "fr-CA" }}) {
        edges {
          node {
            key
            value
          }
        }
      }
    }
  `;
  const data = useStaticQuery(query);

  return kvPairAdapter(data, locale);
};

export default useKeyValuePairs;
